module.exports = __webpack_public_path__ + "media/application/images/2018/2018-pharam-tablets-ce363def406d43d8055e31cf811408cb.jpg";